import React from 'react';
import { Pickaxe } from 'lucide-react';

interface MiningProgressProps {
  miningClicks: number;
  pendingWei: number;
  cycleSize?: number;
}

export function MiningProgress({ miningClicks, pendingWei, cycleSize = 1000 }: MiningProgressProps) {
  const miningProgress = (miningClicks / cycleSize) * 100;
  const currentLevel = Math.floor(miningClicks / cycleSize) + 1;
  const clicksInCurrentCycle = miningClicks % cycleSize;

  return (
    <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 rounded-lg p-6 backdrop-blur-sm border border-gray-700 mb-8">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-yellow-500/20 rounded-lg">
            <Pickaxe className="text-yellow-500" size={24} />
          </div>
          <h3 className="text-xl font-bold text-gray-100">Mining Progress</h3>
        </div>
        <div className="px-4 py-2 bg-yellow-500/20 rounded-full">
          <span className="text-yellow-300 font-bold">Level {currentLevel}</span>
        </div>
      </div>
      
      <div className="relative w-full h-4 bg-gray-700 rounded-full mb-4 overflow-hidden">
        <div 
          className="absolute top-0 left-0 h-full bg-gradient-to-r from-yellow-500 to-yellow-400
            transition-all duration-300 rounded-full"
          style={{ width: `${miningProgress}%` }}
        >
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
          <div className="absolute inset-0 animate-pulse-subtle bg-yellow-400/30" />
        </div>
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
          <span className="text-xs font-bold text-white drop-shadow">
            {clicksInCurrentCycle} / {cycleSize}
          </span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="bg-gray-800/50 rounded-lg p-4">
          <p className="text-gray-400 text-sm mb-1">Mining Power</p>
          <p className="text-2xl font-bold text-yellow-400">
            {clicksInCurrentCycle} <span className="text-lg text-yellow-500/70">clicks</span>
          </p>
        </div>
        <div className="bg-gray-800/50 rounded-lg p-4">
          <p className="text-gray-400 text-sm mb-1">Pending Rewards</p>
          <p className="text-2xl font-bold text-yellow-400">
            {pendingWei} <span className="text-lg text-yellow-500/70">WEI</span>
          </p>
        </div>
      </div>
    </div>
  );
}